var WebWorker = /** @class */function () {
  function WebWorker(worker, workerScirptURL) {
    var code = worker.toString();
    var blob = new Blob(["importScripts('".concat(workerScirptURL, "');(").concat(code, ")()")], {
      type: 'text/javascript'
    });
    return new Worker(URL.createObjectURL(blob));
  }
  return WebWorker;
}();
export default WebWorker;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/g6-pc/es/layout/worker/work.js
// module id = null
// module chunks = 